"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/ImageGroupMessage/Lightbox.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);
var _previewSupport = require('shared/utils/previewSupport');
var _ModalView = require('../FileMessage/FileImage/ModalView'); var _ModalView2 = _interopRequireDefault(_ModalView);
var _ModalView3 = require('../FileMessage/FileVideo/ModalView'); var _ModalView4 = _interopRequireDefault(_ModalView3);


// SAFETY: a delivered grouped image carries the server's FileInfo, with its
// FileKey, or a file reference. One still uploading has neither yet; the
// viewer never opens it, and its Retry passes the missing key on as a lone
// file's does.
 const getFileKey = (row) =>
  _optionalChain([(row.FileInfo ), 'optionalAccess', _ => _.FileKey]) ||
  _optionalChain([row, 'access', _2 => _2.FileReference, 'optionalAccess', _3 => _3.replace, 'call', _4 => _4(/"/g, '')]) ; exports.getFileKey = getFileKey

/* A video of the group: its tile shows a play icon, and the viewer plays it. */
 const isVideoRow = (row) => {
  const info = row.FileInfo 
  return _previewSupport.getMimeFirstMediaKind.call(void 0, _nullishCoalesce(_nullishCoalesce(_optionalChain([info, 'optionalAccess', _5 => _5.Mime]), () => ( _optionalChain([info, 'optionalAccess', _6 => _6.LocalMime]))), () => ( '')), _nullishCoalesce(row.FileName, () => ( ''))) === 'video'
}; exports.isVideoRow = isVideoRow










/* The full-size viewer for a group of images: opens at the clicked one and
 * steps through the group with the arrow buttons or the arrow keys. */
const Lightbox = ({ group, initialMessageKey, onClose, requestOriginal, onDownload }) => {
  // Held by key: the group can change while open (an image recalled or added).
  const [messageKey, setMessageKey] = _react.useState.call(void 0, initialMessageKey)
  // Original links by file key; null once a request finds none.
  const [links, setLinks] = _react.useState({})
  const index = group.findIndex(row => row.MessageKey === messageKey)
  const row = group[index]
  const fileKey = row && exports.getFileKey.call(void 0, row)
  const link = fileKey ? links[fileKey] : undefined
  const hasPrevious = index > 0
  const hasNext = index !== -1 && index < group.length - 1

  // The open image left the group (recalled), so there is nothing to show.
  _react.useEffect.call(void 0, () => { if (index === -1) onClose() }, [index, onClose])

  _react.useEffect.call(void 0, () => {
    if (!fileKey || link !== undefined) return
    let canceled = false
    // A failed request counts as no link, so the viewer says so.
    requestOriginal(fileKey)
      .catch(() => null)
      .then(response => {
        if (!canceled) setLinks(current => ({ ...current, [fileKey]: _optionalChain([response, 'optionalAccess', _7 => _7.Link]) || null }))
      })
    return () => { canceled = true }
  }, [fileKey, link, requestOriginal])

  // The latest group, so the step handlers (and the key listener) stay stable.
  const groupRef = _react.useRef.call(void 0, group)
  _react.useEffect.call(void 0, () => { groupRef.current = group })
  const step = _react.useCallback.call(void 0, (delta) => setMessageKey(key => {
    const keys = groupRef.current.map(groupRow => groupRow.MessageKey)
    return _nullishCoalesce(keys[keys.indexOf(key) + delta], () => ( key))
  }), [])
  const showPrevious = _react.useCallback.call(void 0, () => step(-1), [step])
  const showNext = _react.useCallback.call(void 0, () => step(1), [step])
  const download = _react.useCallback.call(void 0, () => { if (fileKey) onDownload(fileKey) }, [fileKey, onDownload])

  _react.useEffect.call(void 0, () => {
    const handleKeyDown = (event) => {
      if (event.key === 'ArrowLeft') showPrevious()
      if (event.key === 'ArrowRight') showNext()
    }
    window.addEventListener('keydown', handleKeyDown)
    return () => window.removeEventListener('keydown', handleKeyDown)
  }, [showPrevious, showNext])

  if (!row) return null
  const imageCaption = `${row.FileName} (${index + 1} of ${group.length})`

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: true,
      fullScreen: true,
      onClose: onClose,
      className: "file-image--preview-modal",
      bodyClassName: "file-image--preview-modal--body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}}

      ,  link && exports.isVideoRow.call(void 0, row)
        // A video plays in the single video's viewer.
        ? _react2.default.createElement(_ModalView4.default, {
            key: fileKey,
            videoSrc: link,
            videoCaption: imageCaption,
            onClose: onClose,
            onDownload: download, __self: this, __source: {fileName: _jsxFileName, lineNumber: 95}}
          )
        : link
        ? _react2.default.createElement(_ModalView2.default, {
            key: fileKey,
            imageSrc: link,
            imageCaption: imageCaption,
            onClose: onClose,
            onDownload: download, __self: this, __source: {fileName: _jsxFileName, lineNumber: 103}}
          )
        // Loading or unavailable: keep Close in reach (the modal has no
        // title bar of its own, and touch browsers have no Escape key).
        : _react2.default.createElement(_react2.default.Fragment, null
            , _react2.default.createElement(_ModalView.ModalViewHeader, { imageCaption: imageCaption, onClose: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 113}} )
            ,  link === null && (
              _react2.default.createElement('div', { className: "file-image--preview-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 115}}
                , _react2.default.createElement(_Modal.ModalDesc, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 116}}, "We could not open this image. Please try again."        )
              )
            )
          )
      
      ,  hasPrevious && (
        _react2.default.createElement('button', {
          type: "button",
          className: "image-group--lightbox-nav image-group--lightbox-nav-previous" ,
          onClick: showPrevious,
          'aria-label': "Previous image" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 122}}

          , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}, "chevron_left")
        )
      )
      ,  hasNext && (
        _react2.default.createElement('button', {
          type: "button",
          className: "image-group--lightbox-nav image-group--lightbox-nav-next" ,
          onClick: showNext,
          'aria-label': "Next image" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}

          , _react2.default.createElement('i', { className: "material-icons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}, "chevron_right")
        )
      )
    )
  )
}

exports. default = Lightbox
